import { Box, Typography } from '@/shared/ui';

import type { RelatedCode } from '@/features/factsheet';
import RelatedCodeItem from '@/features/factsheet/components/FactsheetView/FactsheetWindow/FactsheetBody/Tabs/RelatedCodesTab/RelatedCodeItem';
import { useIsFactsheetCompact } from '@/features/factsheet/state/useIsFactsheetCompact';

const RelatedCodeList = ({
  title,
  relatedCodes,
  openNewTab
}: {
  title: string;
  relatedCodes: RelatedCode[] | undefined;
  openNewTab: (code: string) => void;
}) => {
  const isCompact = useIsFactsheetCompact();
  return (
    <Box>
      <Typography
        size={isCompact ? 14 : undefined}
        sx={{ fontWeight: 700, pb: 1 }}
      >
        {title}
      </Typography>
      {relatedCodes?.length === 0 && (
        <Typography
          size={isCompact ? 14 : undefined}
          sx={{ pb: 1 }}
        >
          None.
        </Typography>
      )}
      {relatedCodes?.map((relatedCode, index) => (
        <RelatedCodeItem
          key={relatedCode.code + index}
          openNewTab={openNewTab}
          relatedCode={relatedCode}
        />
      ))}
    </Box>
  );
};

export default RelatedCodeList;
